/*
 * Pipe returning the enumeration description
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import {
  Pipe,
  PipeTransform
} from '@angular/core';
import { Enum } from 'app/shared/models/enum.model';

@Pipe({
    name: 'enumDisplayValue',
    standalone: false
})
export class EnumDisplayValuePipe implements PipeTransform {
  transform(key: string, source: Enum[]): string {
    const enumeration = source?.find(s => s.key === key);
    return enumeration?.displayValue || undefined;
  }
}
